export default __webpack_public_path__ + "static/media/applications-image-01.245dceb7.jpg";